import script from "./form_media_cetak.vue?vue&type=script&setup=true&lang=ts"
export * from "./form_media_cetak.vue?vue&type=script&setup=true&lang=ts"

import "./form_media_cetak.vue?vue&type=style&index=0&id=6b1e7978&scoped=true&lang=css"

import exportComponent from "/home/kuradmin/dev-frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b1e7978"]])

export default __exports__